import Vue from 'vue';
import Router from 'vue-router';
import Question from './views/Question.vue';
import LoginRegistrationBlock from './views/LoginRegistrationBlock.vue';
import Result from './views/Results.vue';
import QuestionResult from './views/QuestionsResult.vue';
import MyAccount from './views/MyAccount.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/login',
      name: 'loginregistration',
      component: LoginRegistrationBlock,
    },
    {
      path: '/tests/:id',
      name: 'tests',
      component: MyAccount,
    },
    {
      path: '/result/:id',
      name: 'Result',
      component: Result,
    },
    {
      path: '/result/hero/:id',
      name: 'questionResults',
      component: QuestionResult,
    },
    {
      path: '/:id',
      name: 'question',
      component: Question,
    },
  ],
});
